import FrameworkCourseController from "../../../framework-course.controller";

class Diagram1Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 4;
    this.first = true;
    this.clearDiagramId = 1
    this.exerciseId = 'exercise-1';
    this.pyramidData = {
      exerciseNumber: 1,
      scheme: {
        model: {
          textarea: 'Corporations need to reshape their sales forces’ day-to-day activities to match each customer’s lifetime value',
        },
        children: [
          {
            model: {
              textarea: 'Identify the specific customers and markets you want your sales growth to come from',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Judge the structural potency of your proposition to those sourcec vs competitors\' offerings',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Allocate sales capacity to match the lifetime value of the opportunity',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Only then provide bespoke "by the field for the field" sales tools',
            },
            children: [

            ]
          },
        ],
      },
      instruction: `<p>You are now ready to determine the appropriate Situation, Complication, and Question for the pyramid below. I have indicated the areas in the problem definition from which the information for each part of the introduction can be found.</p>
                    <ol>
                     <li>Situation = Sit</li>
                     <li>Disturbing Event = DE</li>
                     <li>Result 1 = R1</li>
                     <li>Result 2 = R2</li>
                     <li>Solution = Sol</li>
                    </ol>
                    <p>What you want to do now is make a 1 or 2 sentence summary of the essence of what it will say. Once you have done that and pressed Complete, you can take a look at the full introduction I would have written. Now open the Minto Framework and fill in the SCQ.</p>`,
      scq: {
        's-header': 'Sit, DE, R1',
        'c-header': 'Sol, R2'
      },
      opacity: 0.5,
    };
  }

}

export default Diagram1Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5b/diagram1/diagram1.controller.js